import { Alignment, Button, ButtonGroup, Dialog, Icon, IconName, Intent, MaybeElement, Popover, Position } from "@blueprintjs/core"
import { CSSProperties, MouseEvent, useEffect, useState } from "react"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { __ } from "../utilities"

 
interface IProps {
    noButton?: boolean
    buttonIntent?: Intent
    buttonLoading?: boolean
    buttonAlignText?: string
    btnTitle?: string
    buttonLabel?: string | JSX.Element
    btnLabelName?: string
    buttonLarge?:boolean
    buttonFill?:boolean
    buttonMinimal?:boolean
    buttonClassName?: string
    buttonIcon?: MaybeElement | IconName
    buttonDisabled?:boolean
    dialogClasssName?: DIALOG_SIZE
    dialogAddedClassName?: string
    dialogTitle?: string
    children?: JSX.Element
    isOpen?:boolean
    isPopover?: boolean
    popoverPosition?: Position
    popover?: string | JSX.Element
    onDesmiss?: () => void
    onConfirm: (evt : MouseEvent<HTMLElement>) => void
    noLabel?:string | JSX.Element
    yesLabel?:string | JSX.Element
    noLock?:boolean
    yesLock?:boolean
    isHiddenNo?: boolean
    isHiddenYes?: boolean
    buttonSmall?:boolean
    confirm?: string
    buttonStyle?:  CSSProperties
    ["data-testid"]? : string
}
const ConfirmButton = (props: IProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState<boolean>( !!props.isOpen )
    useEffect(() => {
        setIsOpen( !!props.isOpen )
    }, [props.isOpen])
    const onOpen = () => {
        setIsOpen(!isOpen)
    }
    const onClose = () => {
        if(props.onDesmiss)
            props.onDesmiss()
        if(props.noLock) return
        setIsOpen(false)
    }
    const onConfirm = (evt: MouseEvent<HTMLElement>) => {
        props.onConfirm( evt )
        if(props.yesLock) return 
        setIsOpen(false) 
    }
    const btn = props.isPopover
        ?
        <Popover
            interactionKind="hover"
            position={props.popoverPosition}
            content={props.popover}
        >
            <Button 
                intent={props.buttonIntent} 
                alignText={props.buttonAlignText as Alignment}
                size={ props.buttonLarge ? "large" : props.buttonSmall ? "small" : "medium" }
                disabled={props.buttonDisabled}
                fill={props.buttonFill}
                variant={props.buttonMinimal ? "minimal" : "solid"}
                className={props.buttonClassName}
                icon={props.buttonIcon} 
                onClick={onOpen}
                loading={props.buttonLoading}
                data-testid="confirm-button"
                style={props.buttonStyle}
            >
                <div className={props.btnLabelName}>
                    {props.buttonLabel}
                </div>
            </Button>   
        </Popover>
        :
        <Button 
            intent={props.buttonIntent} 
            size={ props.buttonLarge ? "large" : props.buttonSmall ? "small" : "medium" }
            alignText={props.buttonAlignText as Alignment}
            disabled={props.buttonDisabled}
            fill={props.buttonFill}
            variant={props.buttonMinimal ? "minimal" : undefined}
            className={props.buttonClassName}
            icon={props.buttonIcon} 
            onClick={onOpen}
            loading={props.buttonLoading}
            data-testid="confirm-button"
        >
            <div className={props.btnLabelName}>
                {props.buttonLabel}
            </div>
        </Button>
    return <>
        { !props.noButton && btn }
        <Dialog
            className={`${ props.dialogClasssName ? props.dialogClasssName : DIALOG_SIZE.MINIMAL} ${ props.dialogAddedClassName || "" } `}
            isOpen={ isOpen }
            onClose={ isOpen ? onClose : onOpen } 
            title={props.dialogTitle}
        > 
            <div className="d-flex flex-column flex-grow-100">
                <div className="flex-grow-100 ">
                    { 
                        props.confirm 
                            ? 
                            <div className="p-5 lead text-center">{ props.confirm } </div> 
                            : 
                            props.children 
                    } 
                </div>
                <ButtonGroup fill>
                    {
                        !props.isHiddenNo && <Button intent={Intent.DANGER} fill size="large" onClick={onClose} data-testid="no-button">
                            { 
                                typeof props.noLabel === "string" || !props.noLabel
                                    ?
                                    __(props.noLabel || "No")
                                    :
                                    props.noLabel
                            }
                        </Button>
                    }
                    {
                        !props.isHiddenYes && <Button disabled={props.yesLock} intent={props.yesLock ? Intent.NONE : Intent.SUCCESS} fill size="large" onClick={onConfirm} data-testid="yes-button">
                            {
                                typeof props.yesLabel === "string" || !props.yesLabel
                                    ?
                                    __(props.yesLabel || "Yes")
                                    :
                                    props.yesLabel
                            }
                        </Button>
                    }
                </ButtonGroup>
            </div>            
            <Button variant="minimal" onClick={onOpen} className="position-absolute top right px-3 py-2">
                <Icon icon="cross" size={20} color="#FFFFFF"/>
            </Button>
            
        </Dialog>
    </>
} 

export default ConfirmButton